import { ButtonDisplayStyle } from "../../Enums/UiEnums"

export interface IGroupedRowColumnConfig {
    name: string,
    key: string,
    widthPercent: number,
    sortConfig?: IGroupedRowSortConfig
}

export interface IGroupedRow {
    groupLabel: string,
    rows: IGroupedRowItem[]
}

export interface IGroupedRowItem {
    [key: string]: string
}

export interface IGroupedRowActionConfig {
    label: string,
    columnWidthPercent: number,
    actions: IGroupedRowAction[]
}

export interface IGroupedRowAction {
    label: string,
    style: ButtonDisplayStyle,
    action: (row?: IGroupedRowItem) => void
}

export interface IGroupedRowSortConfig {
    sort: (rows: IGroupedRowItem[], direction: IGroupedRowSortDirection) => void
}

export enum IGroupedRowSortDirection {
    ASC,
    DESC
}

export interface IGroupedRowSortState {
    key: string,
    state: IGroupedRowSortDirection | undefined
}
